import { Component, OnInit, HostListener } from "@angular/core";
import { Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";

import general from "@assets/constantes/general.json";

import { ModalDashboardSelectComponent } from "@shared/Components/UserDashboardModalSelect/modal-dashboard-select.component";
import { Home } from "@shared/Entities/General/home.entity";
import { Usuario } from "@shared/Entities/Usuario/usuario.entity";
import { TipoInfo } from "@shared/Enums/tipo-info.enum";
import { OptionType } from "@shared/Interfaces/option.interface";
import { TotalAffiliate } from "@shared/Interfaces/total-affiliate.interface";
import { UserProduct } from "@shared/Interfaces/user-products.interface";
import { HomeRepository } from "@shared/Repositories/home.repository";
import { UsuariosRepository } from "@shared/Repositories/usuarios.repository";

import { UnitSharedService } from "@Unit/shared/services/unitshared.service";
@Component({
  selector: "app-home-en-linea",
  templateUrl: "./home-en-linea.component.html",
  styleUrls: ["./home-en-linea.component.scss"],
})
export class HomeEnLineaComponent implements OnInit {
  public home = new Home();
  public periodicidad;
  public toggled: boolean = false;
  public _ultimosDiasMetricas = general.ultimosDiasMetricas;
  public totalAffiliate$: Observable<TotalAffiliate | null>;
  public bsModalRef: BsModalRef;
  public currentUser: Usuario;

  public products: UserProduct[] = [];

  public isIntermedario: boolean = false;
  public applyBackgroundImage: boolean = false;
  public isUnitPortalStyle: boolean = false;

  constructor(
    private homeRepository: HomeRepository,
    private userRepository: UsuariosRepository,
    private router: Router,
    private modalService: BsModalService,
    private unitSharedService: UnitSharedService
  ) {
    this.checkScreenWidth();
    this.unitSharedService.isUnitPortalStyle$.subscribe((isUnit) => {
      this.isUnitPortalStyle = isUnit;
    });
  }

  public ngOnInit(): void {
    const defaultUltimoDia = this._ultimosDiasMetricas.find((metrica) => metrica.default);

    this.totalAffiliate$ = this.userRepository.getInfoClienteActual().pipe(
      switchMap((user) => {
        this.currentUser = user;
        this.isIntermedario = user?.metadata?.tipoInfo === TipoInfo.Intermediario;

        if (!this.isIntermedario) {
          return of(null);
        }

        return this.homeRepository.getTotalAffiliate().pipe(
          map((total) => {
            return {
              insuranceTotal: new Intl.NumberFormat("en-IN", { maximumSignificantDigits: 3 }).format(total?.insuranceTotal),
              localHealthTotal: new Intl.NumberFormat("en-IN", { maximumSignificantDigits: 3 }).format(total?.localHealthTotal),
            };
          })
        );
      })
    );

    this.homeRepository.getHomePage().subscribe((home) => {
      this.home = home;

      if (this.home.metricasEndPoint) this.selectPeriodicidad(defaultUltimoDia);
    });
  }

  @HostListener("window:resize", ["$event"])
  public onResize(): void {
    this.checkScreenWidth();
  }

  private checkScreenWidth() {
    this.applyBackgroundImage = window.innerWidth >= 1200;
  }

  public checkDashboardSelection(): void {
    if (localStorage.getItem("currentProfile") && this.currentUser?.metadata?.tipoInfo === TipoInfo.PersonalClient) {
      const selectedHomeProductDashboard = localStorage.getItem("selectedDashboard");
      if (selectedHomeProductDashboard) {
        this.router.navigateByUrl(selectedHomeProductDashboard);
        return;
      }
      setTimeout(() => {
        this.verifyHomeCpDashboardSelection();
      }, 3000);
    }
  }

  public toggleMenuView(): void {
    this.toggled = !this.toggled;
  }

  public selectPeriodicidad(option: OptionType): void {
    this.homeRepository.getMetricasHomePage(this.home.metricasEndPoint, option.value).subscribe((newMetricas) => {
      this.periodicidad = option;
      this.home = {
        ...this.home,
        metricas: newMetricas,
      };
    });
  }

  public verifyHomeCpDashboardSelection(): void {
    const isDashboardOpen = localStorage.getItem("dashboardModalOpen");
    if (!isDashboardOpen) {
      const selectedHomeProductDashboard = localStorage.getItem("selectedDashboard");
      if (selectedHomeProductDashboard) {
        this.router.navigateByUrl(selectedHomeProductDashboard);
      } else {
        this.userRepository.getUserProducts().subscribe((products) => {
          this.products = products;

          if (this.products && this.products.length > 1) {
            this.openHomeDashboardSelectModal();
          } else {
            localStorage.setItem("selectedDashboard", this.products[0].url);
            this.router.navigateByUrl(this.products[0].url);
          }
        });
      }
    }
  }

  public openHomeDashboardSelectModal(): void {
    this.bsModalRef = this.modalService.show(ModalDashboardSelectComponent, {
      class: "modal-md",
      initialState: {
        OptionArray: this.products,
      },
    });
  }

  public getBannerBackground(): object {
    return {
      "background-image": this.isUnitPortalStyle
        ? `url('assets/images/Unit/default-home-unit.jpg')`
        : this.home?.manuales?.art
        ? `url('${this.home?.manuales?.art}')`
        : "",
    };
  }

  public displayMetricsByPortal(): boolean {
    return !this.isUnitPortalStyle;
  }
}
